// Преобразует либо в число с двумя знаками после запятой либо в прочерк
export const numberToFixedOrEmpty = (arg: number | undefined | null) => (arg ? arg.toFixed(2) : '-');
